<style>
</style>
<template>
    <div class="privacy">
        <div class="inner-c">
            <div class="main">
                <div class="leftNav">
                    <ul style="margin-top: 130px;">
                        <li @click="chooseNav('agreement0')" ref="agreement0" class="lis">隐私政策</li>
                        <li @click="chooseNav('agreement1')" ref="agreement1" class="lis">侵权投诉</li>
                        <li @click="chooseNav('agreement2')" ref="agreement2" class="lis">苹果支付</li>
                        <li @click="chooseNav('agreement3')" ref="agreement3" class="lis">注册条款</li>
                        <li @click="chooseNav('agreement4')" ref="agreement4" class="lis">社区公约</li>
                        <li @click="chooseNav('agreement5')" ref="agreement5" class="lis">会员协议</li>
                    </ul>
                </div>
                <component :is='currentView' class="routerView" keep-alive ></component>
            </div>
            <!--<router-view class="routerView"></router-view>-->
            <div style="height: 100px;"></div>
        </div>
        <footer class="footerAll">
            <div style="height: 60px;line-height: 60px">
                <div class="" style="width: 960px;height: 100%; margin: 0 auto;font-size: 14px;color: #999;letter-spacing: 0;line-height: 60px;">
                    <ul class="fl" style="height: 100%;">
                        <li class="fl" style="height: 100%;margin-right: 20px;">上海盘隆科技有限公司</li>
                        <li class="fl" style="height: 100%;margin-right: 20px;">粉粉日记©2012-2019</li>
                        <li class="fl" style="height: 100%;"><a href="http://www.miitbeian.gov.cn" target="_blank" style="font-size: 14px;color: #999;letter-spacing: 0;height: 22px;line-height: 22px;margin-top: 19px;">沪ICP备12018816号-1</a></li>
                    </ul>
                    <div class="fr">
                        <span style="cursor:pointer;" @click="goRouter({path: '/joinUs'})">加入我们</span>
                        <span>-</span>
                        <span style="cursor:pointer;" @click="goRouter({path: '/privacy'})">粉粉协议</span>
                        <span>-</span>
                        <span style="cursor:pointer;" @click="goRouter({path: '/help'})">帮助</span>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
    import agreement0 from '../../components/agreement/agreement0.vue'
    import agreement1 from '../../components/agreement/agreement1.vue'
    import agreement2 from '../../components/agreement/agreement2.vue'
    import agreement3 from '../../components/agreement/agreement3.vue'
    import agreement4 from '../../components/agreement/agreement4.vue'
    import agreement5 from '../../components/agreement/agreement5.vue'
    export default {
        data () {
            return {
                currentView: 'agreement0'
            }
        },
        components: {
            agreement0: agreement0,
            agreement1: agreement1,
            agreement2: agreement2,
            agreement3: agreement3,
            agreement4: agreement4,
            agreement5: agreement5
        },
        methods: {
            chooseNav: function (route) {
                this.currentView = route
                this.$store.commit('changeRef', {key: 'agreement', value: route})
                this.changeStyle()
            },
            changeStyle: function () {
                this.$nextTick(() => {
                    let ref = this.$store.state.agreement
                    this.$refs['agreement0'].style.color = "#707070"
                    this.$refs['agreement1'].style.color = "#707070"
                    this.$refs['agreement2'].style.color = "#707070"
                    this.$refs['agreement3'].style.color = "#707070"
                    this.$refs['agreement4'].style.color = "#707070"
                    this.$refs['agreement5'].style.color = "#707070"
                    this.$refs['agreement5'].style.backgroundColor = "rgba(0,0,0,0)"
                    this.$refs['agreement4'].style.backgroundColor = "rgba(0,0,0,0)"
                    this.$refs['agreement3'].style.backgroundColor = "rgba(0,0,0,0)"
                    this.$refs['agreement2'].style.backgroundColor = "rgba(0,0,0,0)"
                    this.$refs['agreement1'].style.backgroundColor = "rgba(0,0,0,0)"
                    this.$refs['agreement0'].style.backgroundColor = "rgba(0,0,0,0)"
                    this.$refs['agreement0'].style.borderLeft = "4px solid rgba(0,0,0,0)"
                    this.$refs['agreement1'].style.borderLeft = "4px solid rgba(0,0,0,0)"
                    this.$refs['agreement2'].style.borderLeft = "4px solid rgba(0,0,0,0)"
                    this.$refs['agreement3'].style.borderLeft = "4px solid rgba(0,0,0,0)"
                    this.$refs['agreement4'].style.borderLeft = "4px solid rgba(0,0,0,0)"
                    this.$refs['agreement5'].style.borderLeft = "4px solid rgba(0,0,0,0)"
                    this.$refs[ref].style.color = "#FF6EA4"
                    this.$refs[ref].style.borderLeft = "4px solid #FF6EA4"
                    this.$refs[ref].style.backgroundColor = "#fff"
                })
            }
        },
        created: function () {
            this.currentView = this.$store.state.agreement
            this.changeStyle()
            trackEvent('agreement')
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/pages/privacy.vue